import { BasicDialogProperties } from "../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2BrokeDialogProperties extends BasicDialogProperties {
    public chips: number = NaN;
    public count: number = 0;

    constructor(chips: number, count: number) {
        super();

        this.chips = chips;
        this.count = count;
    }
}
